import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { BASE_URL } from '../config';

function Modal({close,data}) {
    let navigate = useHistory();
const [disable,setDisable]=useState(true)
    const [formData,setFormData]=useState({
        name:"",
        email:"",
        phoneNumber:"",
        comment:"",
    })
    const [error,setError]=useState(false);
    const [errorMsg,setErrorMsg]=useState("");
    const [success,setSuccess]=useState(false);
    const [successMsg,setSuccessMsg]=useState("");
    const [checkbox,setCheckBox]=useState(false);
    const [price,setPrice]=useState("");
    const [endDate,setEndDate]=useState("");
    const [loading,setLoading]=useState(false);

    const onchange=(e)=>{
        e.preventDefault();
        var reg = /^\d+$/;
        if(disable){
          setDisable(false)
        }
        if(e.target.name==="phoneNumber"){
          if(reg.test(e.target.value)||e.target.value===""){
            setFormData({...formData,[e.target.name]:e.target.value});
          }
        }else{
          setFormData({...formData,[e.target.name]:e.target.value});
        }
    
    };

    const handleSubmit=async(e)=>{
        e.preventDefault();
        setError(false)
// let regExp = /^[a-zA-Z0-9.-]+@[a-zA-Z0-9.-]+\.[A-Za-z]+$/;
let regExp=/^[a-zA-Z0-9.-_]+@[a-zA-Z0-9.-_]+\.[A-Za-z]+$/;
    let numReg=/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
    if (formData.name === ""||/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(formData.name)||/\d/.test(formData.name)){
        setErrorMsg("Please enter only alphabets and spaces in name!")
        return setError(true);
    }
    if (!regExp.test(formData.email)){
      setErrorMsg("Enter valid email address!")
      return setError(true);
  }
  if (/[a-zA-Z]/.test(formData.phoneNumber)||!numReg.test(formData.phoneNumber)){
    setErrorMsg("Please enter valid mobile number!")
    return setError(true);
}
  
  if (formData.comment === ""){
    setErrorMsg("Enter enter comment!")
    return setError(true);
}
let data =new FormData();
data.append('name', formData.name);
data.append('email', formData.email);
data.append('message', formData.comment);
data.append('mobile', formData.phoneNumber);
data.append('course_id', "1");
data.append('amount',price);

var config = {
  method: 'post',
  url: `${BASE_URL}/api/temporder`,
  headers: { 
    'X-Auth-Token': '12345', 
  },
  data : data
};

if(checkbox && !disable){
  setDisable(true)
    await axios(config)
    .then(function (response) {
        let res=response.data;
        console.log(res)
      if(res.code===200){
        if(res.redirect_url){
          // checkoutHandler(res.data.temporary_order_id,e)
          window.location.href=res.redirect_url[0]
        } 
      }else{
        setError(true);
      setErrorMsg("")
      }
    })
    .catch(function (error) {
      // checkoutHandler()
      setError(true);
      setErrorMsg(error.response.data.message[0])
    });
}else{
    setErrorMsg("Please accept & agree to the Terms and Service")
    return setError(true);
}
    }

    const toggleCheckboxChange=()=>{
        // e.prefentDefault();
        setCheckBox(!checkbox);
    }

    const checkoutHandler = async (temporary_order_id,e) => {

      const options = {
          key:`rzp_test_MFXQuDsjcen4OS`,
          amount: price*100,
          currency: "INR",
          name: "CNC MACHINE",
          description: "Learn CNC machine maintence start your own business, get money back within a day. You can earn rs 10000 per day.",
          image: `${BASE_URL}/${data?.logo}`,
          order_id: temporary_order_id,
          handler: async (response) => {
            console.log(response)
            setLoading(true)
            var config = {
              method: 'post',
              url: `${BASE_URL}/api/order`,
              headers: { 
                'X-Auth-Token': '12345', 
              },
              data : {orderid:temporary_order_id,
                paymentid:response.razorpay_payment_id,
                amount:price
              }
            };
           await axios(config).then((res)=>{
              console.log(res);
              if(res.data.code===200){
                setLoading(false)
              setSuccessMsg(res.data.message[0])
        setCheckBox(false)
        setError(false);
        setSuccess(true);
        setFormData({
            name:"",
            email:"",
            phoneNumber:"",
            comment:"",
        });
        callTime(e)
      }else{
        setError(true);
      setErrorMsg(res.data.message[0])
      }
            })
          },
          prefill: {
              name: formData.name,
              email: formData.email,
              contact: formData.phoneNumber
          },
          theme: {
              "color": "#528FF0"
          }
      };
      const razor = new window.Razorpay(options);
      razor.open();
  }

useEffect(() => {
fetchData();
// const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     document.body.appendChild(script);
}, [])
const callTime=(e)=>{
    setTimeout(function() {
        close(e);
    }, 3000);
}
    const fetchData=async()=>{  
   
        let header={
            headers:{
            "X-Auth-Token":"12345"
          }};
        let res= await axios.get(`${BASE_URL}/api/getcourse`,header);
        if(res.data.course){
            setPrice(res.data.course[0].price)
            setEndDate(res.data.course[0].registration_end_date);
        }
    }
  return (
    <div className="modal fade show" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false"  aria-labelledby="staticBackdropLabel" aria-hidden="true" style={{display: "block",paddingRight: "15px"}}>
  <div className="modal-dialog mdlbx" style={{"maxWidth": "460px"}}>
    <div className="modal-content">
      <div className="modal-header">
       
        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={close} aria-label="Close">x</button>
      </div>
      <div className="modal-body" style={{padding:"15px"}}>
        <div className="signup_area">
          <div className="lgin_hedr">
              <h3>Registration</h3>
              <p>Register yourself to book the course</p>
              <h4>{`Fees ₹ ${price}`}</h4>
              <h4>{`Registration End Date: ${endDate&&new Date(endDate).toLocaleDateString('en-GB')}`}</h4>
              
            </div>
              <div className="social_login clearfix">
              {success&&<div className="alert alert-success alert-dismissible" id="suc" >
                        <a href="" className="close" data-dismiss="alert" aria-label="close" onClick={(e)=>{e.preventDefault();setSuccess(false)}}><i className="fa fa-times"></i></a>
                        {successMsg}
                      </div>}
                     {error&& <div className="alert alert-danger alert-dismissible" id="er" >
                        <a href="" className="close" data-dismiss="alert" aria-label="close" onClick={(e)=>{e.preventDefault();setError(false)}}><i className="fa fa-times"></i></a>
                        {errorMsg}   
                      </div>}
                            <form onSubmit={handleSubmit}>
                            <div className="row nopd">
                            <div className="col-sm-12 col-lg-12 col-md-12">
                                  <div className="your-mail">
                                    <input className="form-control" name='name' onChange={onchange} id="exampleInputEmail1" value={formData.name} placeholder="Name" type="text"/>
                                  </div>
                                  </div>
                                  
                                  <div className="col-sm-12 col-lg-12 col-md-12">
                                  <div className="your-mail">
                                    <input className="form-control" name="email" onChange={onchange} id="exampleInputEmail1" value={formData.email} placeholder="Email" type="email"/>
                                  </div>
                                  </div>

                                  <div className="col-sm-12 col-lg-12 col-md-12">
                                  <div className="your-mail">
                                    <input className="form-control" name='phoneNumber' onChange={onchange} id="exampleInputEmail1" value={formData.phoneNumber} placeholder="Phone Number" type="text"/>
                                  </div>
                                  </div>
                                  {loading&&<div className="loader-container" style={{position:"absolute",height:"200px"}}>
        <div className="spinner"></div>
      </div>}
                                  <div className="col-sm-12 col-lg-12 col-md-12">
                                  <div className="your-mail">
                                  
                                   <textarea style={{padding:"10px 20px"}} className="form-control" name="comment" onChange={onchange} value={formData.comment}  placeholder="Message" rows="4"></textarea>
                                  </div>
                                  </div>

                                  <div className="col-sm-12 col-lg-12 col-md-12 lgn_section">
                                    <div className="checkbox-group"> 
                                    <input id="checkiz" type="checkbox" value={checkbox} checked={checkbox} onClick={toggleCheckboxChange}/> 
                                    <label for="checkiz" className="Fs16 css-tooltip-right color-orange"  >
                                        <span className="check"></span>
                                        <span className="box W25"></span>
                                        I accept & agree to the <a href="/terms-conditions" onClick={(e)=>{e.preventDefault();navigate.push("/terms-conditions");close(e)}}>Terms of Service</a>
                                     </label>
                                    </div>
                                   </div>
                                   <div className="submit-login">
                            {/* <button type="submit" className="contact-us-form">Send Your Message</button> */}
                                    <button  disabled={disable} type="submit" className="btn btn-default">Book Now</button>
                                  </div>
                               </div>
                                  
                            </form>
                             
                               {/* </form> */}
                            
                            
                        </div>
                        
                        
            
        </div>
      </div>

    </div>
  </div>
  
</div>
  )
}

export default Modal